<script lang="ts">
  /**
   * Base Svelte scene. All game scenes wrap their content in this component.
   * Provides consistent ESC handling, aria-live announcement, and focus management.
   */
  import { onMount, onDestroy } from "svelte";

  export let sceneId: string;
  export let ariaLabel: string;
  export let onEscape: (() => void) | undefined = undefined;

  let root: HTMLElement;

  function handleKeydown(e: KeyboardEvent): void {
    if (e.key === "Escape" && onEscape) {
      onEscape();
      e.preventDefault();
    }
  }

  onMount(() => {
    root?.focus();
    window.addEventListener("keydown", handleKeydown);
  });

  onDestroy(() => {
    window.removeEventListener("keydown", handleKeydown);
  });
</script>

<section
  bind:this={root}
  class="scene"
  data-scene-id={sceneId}
  aria-label={ariaLabel}
  tabindex="-1"
>
  <slot />
</section>

<style>
  .scene {
    width: 100%;
    min-height: 100vh;
    outline: none;
  }
  .scene:focus-visible {
    outline: 2px solid var(--focus-ring, #ffcc00);
    outline-offset: -2px;
  }
</style>
